import React from 'react';
import PropTypes from 'prop-types';
import DORSigningLinkButton from './DORSigningLinkButton';
import DownloadDORButton from './DownloadDORButton';
import { languageLabels } from '../../claims/claimsHelpers';

function DORButtonDropdown(props) {
  const { shipmentId, trackingCode, availableDORLanguages, type, recipientEmail } = props;

  const mappedAvailableLanguages = availableDORLanguages
    .map((language) => ({ key: language, value: languageLabels[language] || language.toUpperCase() }))
    .sort((a, b) => a.value.localeCompare(b.value));

  if (type === 'dor-signing-link') {
    return (
      <DORSigningLinkButton
        languages={mappedAvailableLanguages}
        recipientEmail={recipientEmail}
        shipmentId={shipmentId}
      />
    );
  }

  return <DownloadDORButton languages={mappedAvailableLanguages} shipmentId={shipmentId} trackingCode={trackingCode} />;
}

DORButtonDropdown.propTypes = {
  shipmentId: PropTypes.number,
  trackingCode: PropTypes.string,
  type: PropTypes.string,
  availableDORLanguages: PropTypes.array,
};

export default React.memo(DORButtonDropdown);
